import { Controller } from 'stimulus';
import Inputmask from "inputmask";

export default class extends Controller {
  static targets = ['countryCodeSelect', 'input'];

  connect() {
    this.setInputmask(this.countryCodeSelectTarget.value, this.inputTarget.value);
  }

  updateCountryCode(ev) {
    const { target: { value } } = ev;

    this.setInputmask(value, this.inputTarget.value);
  }

  updatePhoneNumber(ev) {
    const { target: { value } } = ev;

    this.setInputmask(this.countryCodeSelectTarget.value, value);
  }

  setInputmask(countryCode, phoneNumber){
    switch (countryCode) {
      case 'US':
        this.regex = "\\d{3}\-\\d{3}\-\\d{4}$"
      break;
      case 'AU':
         // mobile 04xx xxx xxx 
         // this.regex = "\\d{4} \\d{3}\ \\d{3}$"
         // land line 02 xxxx xxxx
         this.regex = "\\d{2} \\d{4}\ \\d{4}$"
      break;
      case 'CA':
        this.regex = "\\d{3}\-\\d{3}\-\\d{4}$"
      break;
      case 'GB':
        // mobile 07xxx xxxxxx
        // land line 0xxxx xxxxxx
        // (020) xxxx xxxx	London
        // (029) xxxx xxxx	Cardiff
        // (0113) xxx xxxx	Leeds
        // (0116) xxx xxxx	Leicester
        // (0121) xxx xxxx	Birmingham
        // (0151) xxx xxxx	Liverpool
        // (01204) xxxxx	Bolton
        // (015396) xxxxx	Sedbergh
        // (01382) xxxxxx	Dundee
        // (01386) xxxxxx	Evesham
        // (01865) xxxxxx	Oxford
        // (016977) xxxx or (016977) xxxxx	Brampton

        if (phoneNumber.startsWith('2', 1)) {
          this.regex = "\\d{3}\ \\d{4} \\d{4}$"
        } else if (phoneNumber.startsWith('1', 1)) {
          if (phoneNumber.startsWith('2', 2)) {
            if (phoneNumber.startsWith('0', 3)) {
              this.regex = "\\d{5}\ \\d{5}\$"
            } else {
              this.regex = "\\d{4}\ \\d{3} \\d{4}$"
            }
          } else if (phoneNumber.startsWith('5', 2)) {
            if (phoneNumber.startsWith('3', 3)) {
              this.regex = "\\d{6}\ \\d{5}$"
            } else {
              this.regex = "\\d{4}\ \\d{3} \\d{4}$"
            }
          } else if (phoneNumber.startsWith('3', 2) || phoneNumber.startsWith('8', 2)) {
            this.regex = "\\d{5}\ \\d{6}$"
          } else if (phoneNumber.startsWith('6', 2)) {
            this.regex = "\\d{6}\ \\d{5}$"
          } else {
            this.regex = "\\d{4}\ \\d{3} \\d{4}$"
          }
        } else {
          this.regex = "\\d{3}\ \\d{4} \\d{4}$"
        }
      break;
      }

    Inputmask({
      regex: this.regex,
      clearMaskOnLostFocus: false,
    }).mask(this.inputTarget); 
  }
}
